<template>
  <section
    class="w-screen h-full bg-white fixed left-0 top-0 z-50 overflow-auto"
  >
    <div id="banner" class="shadow-md w-full sticky top-0 z-50">
      <div class="flex items-center relative">
        <Banner
          :hiddenIcon="!hasIcon"
          :image="headerInfo?.icon"
          :title="headerInfo?.title"
          :subtitle="headerInfo?.subtitle"
          class="w-full"
        >
          <template #content v-if="!hiddenCloseButton">
            <Button
              :class="`${
                closeDanger ? 'btn-delete-block' : 'btn-primary'
              } w-[60px] h-[20px] sm:w-[100px] sm:h-[40px] rounded-md flex items-center justify-center p-0`"
              @click="onClose"
            >
              <p class="sm:text-[16px] text-[12px]">
                {{ $t("labels.generic", { pt: "Fechar", en: "Close" }) }}
              </p>
            </Button>
          </template>
        </Banner>
      </div>
    </div>

    <div class="flex flex-col gap-3 p-8">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "courseContent",
  emits: ["onClose"],
  props: {
    headerInfo: {
      type: Object as PropType<any>,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    hiddenCloseButton: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    closeDanger: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  unmounted() {
    document.body.style.overflow = "auto";
  },
  methods: {
    onClose(): void {
      this.$emit("onClose");
    },
  },
});
</script>
